import { ParticipationHeaderProps } from "./../types";
import { useReflectionHeaderProps } from "./useReflectionHeaderProps";
import { HeaderReflection } from "../../../../components/header-reflection";

export function ReflectionHeaderWrapper(props: ParticipationHeaderProps) {
  const headerProps = useReflectionHeaderProps(props);
  return <HeaderReflection {...headerProps} />;
}
